(function () {
  'use strict';

  // Scroll reveal
  var revealEls = document.querySelectorAll('.qw-reveal, .qw-reveal-stagger');
  if ('IntersectionObserver' in window && revealEls.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-visible'); });
  }

  // Header: sticky scroll shadow, search toggle, mobile menu toggle
  document.querySelectorAll('.header-custom').forEach(function (header) {
    var onScroll = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 4);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    var searchToggle = header.querySelector('[data-search-toggle]');
    var searchPanel = header.querySelector('[data-search-panel]');
    if (searchToggle && searchPanel) {
      searchToggle.addEventListener('click', function () {
        var isOpen = searchPanel.classList.toggle('is-open');
        searchPanel.hidden = !isOpen;
        searchToggle.setAttribute('aria-expanded', String(isOpen));
        if (isOpen) {
          var input = searchPanel.querySelector('input[type="search"]');
          if (input) window.requestAnimationFrame(function () { input.focus(); });
        }
      });
    }

    var menuToggle = header.querySelector('[data-mobile-menu-toggle]');
    var mobileNav = header.querySelector('[data-mobile-nav]');
    if (menuToggle && mobileNav) {
      menuToggle.addEventListener('click', function () {
        var isOpen = mobileNav.classList.toggle('is-open');
        mobileNav.hidden = !isOpen;
        menuToggle.setAttribute('aria-expanded', String(isOpen));
      });
    }
  });
})();
